import axios from 'axios';
import { GroupChatMessResult } from 'common/interfaces/api';

export const getMessagesByGroup = async (groupId: string, page: number) => {
  return (await axios.get(`/chats/groups/${groupId}/messages?page=${page}`))
    ?.data as GroupChatMessResult;
};
